import { render } from "./DownloadNodeTemplate.vue?vue&type=template&id=32e3078f"
import script from "./DownloadNodeTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadNodeTemplate.vue?vue&type=script&lang=js"

import "./DownloadNodeTemplate.vue?vue&type=style&index=0&id=32e3078f&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__